import { connect } from 'react-redux';

import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ChannelTypes } from '../types/ChannelTypes';
import { ContentInfoCardChannel, ContentInfoChannelOwnProps, ContentInfoChannelProps } from './ContentInfoCardChannel';

export const ConnectedHomeRecommendationsChannel = connect((state: AppState, props: ContentInfoChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(state);

  var recsList: IContentInfo[] = state.home.recommendations.items.map(contentId => state.normalizedContentById[contentId]);

  const recommendationChannelProps: ContentInfoChannelProps = {
    channelType: ChannelTypes.recommendations,
    title: Messages.home_recommendationsTitle(),
    seeAllUrl: siteUrls.recommendationListUrl(),
    seeAllAltText: Messages.home_recommendations_alt_seeAll(),
    list: recsList,
    isFetching: state.home.recommendations.isFetching,
    numRows: 1,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state)
  };
  return recommendationChannelProps;
})(ContentInfoCardChannel);
